import * as React from "react";
import { SVGProps, memo } from "react";

const SvgSendMedicine = (props: SVGProps<SVGSVGElement>) => (
  <svg width={82} height={74} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m57.5 34.315 14 6.588V64h-28V40.903l14-6.588Zm-17 5.954a2 2 0 0 1 1.148-1.81l15-7.059a2 2 0 0 1 1.704 0l15 7.06a2 2 0 0 1 1.148 1.809v24.73a2 2 0 0 1-2 2h-30a2 2 0 0 1-2-2V40.27Zm15.94 3.671a5.743 5.743 0 1 1 8.12 8.121l-6 6a5.743 5.743 0 0 1-8.12-8.12l6-6Zm6 2.121a2.743 2.743 0 0 0-3.88 0l-2.939 2.94 3.879 3.878 2.94-2.939a2.743 2.743 0 0 0 0-3.879Z"
      fill="#0F72BD"
    />

    <path
      d="M30.197 48.532a.642.642 0 0 0-1.082.468v7.985a.642.642 0 0 0 1.082.468l4.25-3.99a.642.642 0 0 0 0-.937l-4.25-3.994Z"
      fill="#0F72BD"
      stroke="#0F72BD"
      strokeWidth={1.285}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      opacity={0.5}
      d="M23.568 48.532a.642.642 0 0 0-1.082.468v7.985a.642.642 0 0 0 1.082.468l4.25-3.99a.642.642 0 0 0 0-.937l-4.25-3.994Z"
      fill="#0F72BD"
      stroke="#0F72BD"
      strokeWidth={1.285}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      opacity={0.25}
      d="M16.94 48.532a.642.642 0 0 0-1.082.468v7.985a.642.642 0 0 0 1.082.468l4.25-3.99a.643.643 0 0 0 0-.937l-4.25-3.994Z"
      fill="#0F72BD"
      stroke="#0F72BD"
      strokeWidth={1.285}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M15.041 30.583h10.917c.354 0 .65-.12.89-.361s.36-.54.36-.896c0-.357-.12-.653-.36-.889a1.219 1.219 0 0 0-.89-.354H15.04c-.354 0-.651.12-.89.362-.24.24-.36.54-.36.895 0 .357.12.653.36.889.239.236.536.354.89.354Zm0-7.083h10.917c.354 0 .65-.12.89-.362.24-.24.36-.54.36-.896s-.12-.652-.36-.888a1.219 1.219 0 0 0-.89-.354H15.04c-.354 0-.651.12-.89.361-.24.241-.36.54-.36.896s.12.652.36.888c.239.237.536.355.89.355ZM9.666 37.666c-.667 0-1.25-.25-1.75-.75s-.75-1.083-.75-1.75V6.833c0-.667.25-1.25.75-1.75s1.083-.75 1.75-.75h14c.346 0 .675.07.988.208.314.14.581.32.804.542l7.625 7.625c.222.222.403.49.541.803.14.314.209.643.209.989v20.666c0 .667-.25 1.25-.75 1.75s-1.084.75-1.75.75H9.666Zm13.792-24.333v-6.5H9.666v28.333h21.667V14.583h-6.625a1.21 1.21 0 0 1-.89-.36 1.21 1.21 0 0 1-.36-.89Z"
      fill="#0F72BD"
    />
  </svg>
);

const Memo = memo(SvgSendMedicine);

export default Memo;
